import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils/utils';
// A small square image; without a src it shows the first letter of alt instead.
export const Thumbnail = ({ src, alt, className, ...props }) => {
    if (src) {
        return (_jsx("img", { ...props, src: src, alt: alt, className: cn('size-7 shrink-0 rounded-md bg-neutral-100 object-cover', className) }));
    }
    return (_jsx("span", { "aria-hidden": "true", className: cn('flex size-7 shrink-0 items-center justify-center rounded-md bg-neutral-100 font-roobert text-xs font-medium text-neutral-500', className), children: alt.trim().charAt(0).toUpperCase() }));
};
